import { createEtDom, mountedToDom } from "utils";
import { getIsMobile } from "utils/device";

const etParams = {
  excluded_blocks: [".inlineCart .check-button-group", '.module-popup .g'],
  extra_definitions: [
    {
      type: 13,
      selector: "[data-title]",
      attribute: "data-title",
    },
    {
      type: 14,
      selector: "[data-description]",
      attribute: "data-description",
    },
  ],
};

/** 挂载到header */
const mountedToHeader = (): void => {
  // 挂载到挂载点
  mountedToDom(["HeaderLinkBarBefore"], () => {
    return createEtDom("div", false, etParams);
  });
};

/** 挂载到车边栏 */
const mountedToDrawer = (): void => {
  mountedToDom(["HeaderDrawerMenuAccountPrev"], () => {
    const dom = createEtDom("div", true, etParams);

    // 包一层<li>标签
    const li = document.createElement("li");
    li.classList.add("et-wrapper");
    li.append(dom);

    return li;
  });
};

const translateVogue = function () {
  // 先进行翻译初始化
  const mobileWidth = 767; // 移动端屏幕宽度临界值，< 768px 为移动端
  let isMobile = getIsMobile(mobileWidth); // 是否是移动端

  const isOrderPage = new RegExp(/\/order?-\w+|orders\/\d+/).test(
    location.pathname
  );

  if (isOrderPage) {
    createEtDom("div", isMobile, etParams);

    return;
  }

  // pc
  if (!isMobile) {
    // 挂载到页头菜单
    mountedToHeader();
  } else {
    // mobile
    mountedToDrawer();
  }
};

export { translateVogue };
